import { render } from "./Reports.vue?vue&type=template&id=6b91c411&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"

import "./Reports.vue?vue&type=style&index=0&id=6b91c411&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b91c411"

export default script